import React, {useContext, useState} from 'react';
import OrgPage from "../../../components/OrgPage";
import EditOrgWithDaData from "../../../components/Modals/EditOrgWithDaData";
import DaDataModal from "../../../components/Modals/DaDataModal";
import {AuthContext} from "../../../context/AuthContext";


function MedCenterList() {
    const baseURL = process.env.REACT_APP_BASE_URL
    const [modal, showModal] = useState()
    const [editModal, showEditModal] = useState()
    const [modalId, setModalId] = useState()
    const [refresh, setRefresh] = useState(false)

const userId = useContext(AuthContext)?.token?.userId
    const editMedCenter = (data) => {
        setModalId(data)
        showEditModal(true)
    }

    const closeHandler = () => {
        showModal(false)
        showEditModal(false)
        setRefresh(!refresh)
    }

    tableModel.haveToShow[0].typeData.onClick = editMedCenter
    return (
        <>
            {editModal
                ? <EditOrgWithDaData id={modalId} closeHandler={closeHandler}
                                     url={""}/>
                : ''}
            {modal
                ? <DaDataModal closeHandler={closeHandler} role={4} url={`/api/v2/verificationCenters/${userId}/medCenters`}/>
                : ''}
            <OrgPage
                refresh={refresh}
                url={`${baseURL}/api/v2/verificationCenters/${userId}/medCenters?`}
                firstRow={tableModel.firstRow}
                haveToShow={tableModel.haveToShow}
                breadCrumbsItems={[
                    {title: 'Контрагенты'},
                    {title: 'Мед. центры', actual: true},
                ]}
                addOrg={{
                    med: true,
                    onClick() {
                        showModal(true)
                    }
                }}
                filterBarButtons={{
                    downloadTemplate: {
                        show: false,
                        url: '/'
                    }
                }}

                filterFieldsConf={{
                    name: true,
                    inn: true,
                    date: true,
                    period: true,
                }}
            />
        </>
    );
}

export default MedCenterList;

var tableModel =
    {
        firstRow:
            [
                {title: 'Название', id: 'med_name'},
                {title: 'Количество людей', id: ''},  // Сортировка не добавлена
                {title: 'Количество организаций', id: ''},  // Сортировка не добавлена
                {title: 'Вызов', id: ''}, // Сортировка не добавлена

            ],
        haveToShow: [
            {
                id: 'med_name',
                type: 'linkCell',
                idArr: ['id'],
                typeData: {onClick: _ => {}, route: '/counterAgents/MedCenterOrgList'}
            },
            {id: 'patients_count'},
            {id: 'org_count'},
            {id: 'invite_count'},],
    }
